import actions from './actions';

const initState = {
    packages: [],
    errors: {},
    loading: false,
    editView: false,
};

const updatePackagesReducer = (state = initState, action) => {
    switch(action.type) {
        case actions.FETCH_UPDATE_PACKAGES:
            return {
                ...state,
                loading: true,
                editView: false,
            };
        case actions.FETCH_UPDATE_PACKAGES_SUCCESS:
            return {
                ...state,
                packages: action.packages,
                loading: false,
                editView: false
            }
        default:
            return state;
    }
};

export default updatePackagesReducer;